import { ActionType } from "typesafe-actions";
import * as actions from "./actions";
import { getHallFloorsSuccess } from "./actions";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  callApiDelete,
  callApiGet,
  callApiPost,
  callApiPut,
} from "../../utils/api";
import { HallFloorActionTypes } from "./types";
import { message } from "antd";

type GetHallFloorsAction = ActionType<typeof actions.getHallFloors>;
type GetHallFloorAction = ActionType<typeof actions.getHallFloor>;
type CreateHallFloorsAction = ActionType<typeof actions.createHallFloor>;
type UpdateHallFloorsAction = ActionType<typeof actions.updateHallFloor>;
type DeleteHallFloorAction = ActionType<typeof actions.deleteHallFloor>;

function* getHallFloors({ payload }: GetHallFloorsAction) {
  try {
    const response = yield call(callApiGet, `halls/${payload}/floors`);
    yield put(getHallFloorsSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallFloorsFailure(error.response.data));
  }
}

function* getHallFloor({ payload }: GetHallFloorAction) {
  try {
    const response = yield call(
      callApiGet,
      `halls/${payload.hallId}/floors/${payload.id}`
    );
    yield put(actions.getHallFloorSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallFloorFailure(error.response.data));
  }
}

function* createHallFloor({ payload }: CreateHallFloorsAction) {
  try {
    const response = yield call(
      callApiPost,
      `halls/${payload.hall_id}/floors`,
      payload
    );
    yield put(actions.createHallFloorSuccess(response.data));
    message.success("Floor created successfully");
  } catch (error: any) {
    yield put(actions.createHallFloorFailure(error.response.data));
    message.error("Failed to create floor. Please try again");
  }
}

function* updateHallFloor({ payload }: UpdateHallFloorsAction) {
  try {
    const response = yield call(
      callApiPut,
      `halls/${payload.hall_id}/floors`,
      payload,
      payload.id
    );
    yield put(actions.updateHallFloorSuccess(response.data));
    message.success("Floor updated successfully");
  } catch (error: any) {
    yield put(actions.updateHallFloorFailure(error.response.data));
    message.error("Failed to update floor. Please try again");
  }
}

function* deleteHallFloor({ payload }: DeleteHallFloorAction) {
  try {
    const response = yield call(
      callApiDelete,
      `halls/${payload.hallId}/floors`,
      payload.id
    );
    yield put(actions.deleteHallFloorSuccess(response.data));
    message.success("Floor deleted successfully");
  } catch (error: any) {
    yield put(actions.deleteHallFloorFailure(error.response.data));
    message.error("Failed to delete floor. Please try again");
  }
}

function* watchGetHallFloors() {
  yield takeEvery(HallFloorActionTypes.FETCH_FLOORS_REQUEST, getHallFloors);
}

function* watchCreateHallFloor() {
  yield takeEvery(HallFloorActionTypes.CREATE_FLOOR_REQUEST, createHallFloor);
}

function* watchUpdateHallFloor() {
  yield takeEvery(HallFloorActionTypes.UPDATE_FLOOR_REQUEST, updateHallFloor);
}

function* watchGetHallFloor() {
  yield takeEvery(HallFloorActionTypes.FETCH_FLOOR_REQUEST, getHallFloor);
}

function* watchDeleteHallFloor() {
  yield takeEvery(HallFloorActionTypes.DELETE_FLOOR_REQUEST, deleteHallFloor);
}

export function* HallFloorsSaga() {
  yield all([
    fork(watchGetHallFloors),
    fork(watchCreateHallFloor),
    fork(watchUpdateHallFloor),
    fork(watchGetHallFloor),
    fork(watchDeleteHallFloor),
  ]);
}
